<template>
  <div style="height: 100%" class="border-r border-gray-300 border-solid">
    <div class="w-full text-center">
      <a-avatar :size="80">{{ userInfo.name.substring(0, 1) }}</a-avatar>
    </div>
    <div class="py-4 text-center left-8">{{ userInfo.name }}</div>
    <a-menu :selectedKeys="selectedKeys" style="width: 128px" @click="menuClick">
      <a-menu-item :key="0">保函订单</a-menu-item>
      <a-menu-item :key="2">我的信息</a-menu-item>
      <!-- <a-menu-item :key="3">企业信息</a-menu-item> -->
      <!-- <a-menu-item :key="4" v-if="permission(['report', 'linhai'], '')">报表-临海</a-menu-item>
      <a-menu-item :key="6" v-if="permission(['report', 'wenling'], '')">报表-温岭</a-menu-item>
      <a-menu-item :key="7" v-if="permission(['report', 'yuhuan'], '')">报表-玉环</a-menu-item> -->
      <a-menu-item :key="5" v-if="permission(['contract', 'apply/:id?'], 'puser')"
        >推荐订单</a-menu-item
      >
    </a-menu>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import permission from '@/utils/permission';
  export default {
    props: {
      selectedKeys: Array,
    },
    computed: {
      ...mapState('user', ['userInfo']),
    },
    methods: {
      permission,
      menuClick({ key }) {
        switch (key) {
          case 0:
            this.$router.push('/admin/contract');
            break;
          case 1:
            this.$router.push('/admin/myteam');
            break;
          case 2:
            this.$router.push('/admin/info');
            break;
          case 3:
            this.$router.push('/admin/company');
            break;
          case 4:
            this.$router.push('/admin/report_linhai');
            break;
          case 5:
            this.$router.push('/admin/p_contract');
            break;
          case 6:
            this.$router.push('/admin/report_wenling');
            break;
          case 7:
            this.$router.push('/admin/report_yuhuan');
            break;
        }
      },
    },
  };
</script>
